import Table from "react-bootstrap/Table";

function DetailsTable() {
  //3366ff
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>
            Information
          </th>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>
            Details
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Name of the School</td>
          <td>Kanchan Vidya Mandir Sr. Sec. School</td>
        </tr>
        <tr>
          <td>Affiliation Number</td>
          <td>532331</td>
        </tr>
        <tr>
          <td>School Code</td>
          <td>42394</td>
        </tr>
        <tr>
          <td>Complete Address with Pincode</td>
          <td>
            Rajeev Colony, (Jharsaintly) Sec.-56 Ballabgarh, Faridabad-121004
          </td>
        </tr>
        <tr>
          <td>Principal Name </td>
          <td>Ms. Pinki Kaushik</td>
        </tr>
        <tr>
          <td>Qualification</td>
          <td>M.com, Bed.</td>
        </tr>
        <tr>
          <td>School Email ID</td>
          <td>kanchanschool3370@gmail.com</td>
        </tr>
        <tr>
          <td>Contact Details Number</td>
          <td>9899560650 </td>
        </tr>
        {/* <tr>
          <td>3</td>
          <td colSpan={2}>Larry the Bird</td>
          <td>@twitter</td>
        </tr> */}
      </tbody>
    </Table>
  );
}

export default DetailsTable;
